import { eventEmitter } from "@/utils/event-emitter.js";
import { appState } from "@/utils/state.js";
import { setLS } from "@/utils/local-storage.js";

export function saveGame() {
  eventEmitter.on("saveGame", () => {
    const gameData = appState.getAllState();
    setLS("savedGame", gameData);
    console.log(gameData);
  });
}
